import { css } from '@emotion/react';
import { ReactNode } from 'react';

export const FormFooter = ({ children }: { children: ReactNode }) => {
	return (
		<div
			css={css`
				margin: 32px 0 40px;
				display: flex;
				justify-content: space-between;
			`}
		>
			{children}
		</div>
	);
};
